import styled from 'styled-components';
const SimpleIntroWrapper = styled.div`
    .profile-widget-image {
        img {
            width: 92px;
            height: 92px;
            object-fit: cover;
            border-radius: 0.25rem;
        }
    }
`;

export default SimpleIntroWrapper;